import { gql } from "@apollo/client";

export const PRODUCT_UOM_LIST = gql`
  query productUomList(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
    $primaryUnit: String
    $secondaryUnit: String
    $orderBy: String
    $uomName: String
  ) {
    productUomList(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      primaryUnit: $primaryUnit
      secondaryUnit: $secondaryUnit
      orderBy: $orderBy
      uomName: $uomName
    ) {
      edges {
        node {
          objectId
          id
          uomName
          primaryUnit
          secondaryUnit
          size
          uomProducts {
            edges {
              node {
                objectId
                primaryStock
                secondaryStock
                purchasePrice
                salesPrice
                batch
                purchaseVatPercent
                salesVatPercent
                product {
                  productName
                }
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

export const GET_ALL_PRODUCT_UOM_LIST = gql`
  query productUomList(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
    $primaryUnit: String
    $secondaryUnit: String
    $orderBy: String
    $uomName: String
  ) {
    productUomList(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      primaryUnit: $primaryUnit
      secondaryUnit: $secondaryUnit
      orderBy: $orderBy
      uomName: $uomName
    ) {
      edges {
        node {
          objectId
          id
          uomName
          primaryUnit
          secondaryUnit
          size
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

export const PRODUCT_UOM = gql`
  query productUom($objectId: ID!) {
    productUom(objectId: $objectId) {
      objectId
      uomName
      primaryUnit
      secondaryUnit
      size
    }
  }
`;
